import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './css/menu.css';
import logoLight from '../../img/logo.png';
import logoWhite from '../../img/LogoW.png';

const Menu = ({ dark = false, marginBottom = 40, padding = '30px 0', isFooter = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handleLogoClick = (e) => {
    scrollToTop();
    closeMenu();
  };

  const handleMenuClick = (sectionId = null) => {
    if (sectionId) {
      scrollToSection(sectionId);
    }
    closeMenu();
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      if (window.scrollY > 100) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  if (isFooter) {
    return (
      <nav className={`menu-nav menu-nav--footer ${dark ? 'menu-nav--dark' : ''}`}>
        <div className="menu-container">
          <div className="menu-logo">
            <Link 
              to="/" 
              onClick={handleLogoClick}
              style={{ display: 'block', textDecoration: 'none' }}
            >
              <img 
                src={dark ? logoWhite : logoLight} 
                alt="ALTCOR AI" 
                className="logo-img" 
              />
            </Link>
          </div>

          <ul className="menu-list menu-list--footer">
            <li><Link to="/#how" className="menu-link" onClick={() => scrollToSection('how')}>Как это работает</Link></li>
            <li><Link to="/#benefits" className="menu-link" onClick={() => scrollToSection('benefits')}>Преимущества</Link></li>
            <li><Link to="/#tariffs" className="menu-link" onClick={() => scrollToSection('tariffs')}>Тарифы</Link></li>
            <li><Link to="/#docs" className="menu-link" onClick={() => scrollToSection('docs')}>Документация</Link></li>
            <li><Link to="/#contact" className="menu-link" onClick={() => scrollToSection('contact')}>Контакты</Link></li>
          </ul>
        </div>
      </nav>
    );
  }

  return (
    <nav 
      className={`menu-nav ${dark ? 'menu-nav--dark' : ''} ${isScrolled ? 'menu-nav--scrolled' : ''} ${isMenuOpen ? 'menu-nav--open' : ''}`}
    >
      <div className="menu-container">
        <div className="menu-logo">
          <Link 
            to="/" 
            onClick={handleLogoClick}
            style={{ display: 'block', textDecoration: 'none' }}
          >
            <img 
              src={dark ? logoWhite : logoLight} 
              alt="ALTCOR AI" 
              className="logo-img" 
            />
          </Link>
        </div>

        <button 
          className={`menu-toggle ${isMenuOpen ? 'menu-toggle--active' : ''}`}
          onClick={toggleMenu}
          aria-label="Открыть меню"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`menu-mobile-content ${isMenuOpen ? 'menu-mobile-content--open' : ''}`}>
          <div className="menu-mobile-header">
            <div className="menu-mobile-logo">
              <Link 
                to="/" 
                onClick={handleLogoClick}
                style={{ display: 'block', textDecoration: 'none' }}
              >
                <img 
                  src={dark ? logoWhite : logoLight} 
                  alt="ALTCOR AI" 
                  className="logo-img" 
                />
              </Link>
            </div>
            
            <button 
              className="menu-close"
              onClick={closeMenu}
              aria-label="Закрыть меню"
            >
              <span></span>
              <span></span>
            </button>
          </div>

          <ul className={`menu-list ${isMenuOpen ? 'menu-list--open' : ''}`}>
            <li>
              <Link 
                to="/#altcor-ai" 
                className="menu-link" 
                onClick={() => handleMenuClick('altcor-ai')}
              >
                ALTCOR AI
              </Link>
            </li>
            <li>
              <Link 
                to="/#how-it-works" 
                className="menu-link" 
                onClick={() => handleMenuClick('how-it-works')}
              >
                Как это работает
              </Link>
            </li>
            <li>
              <Link 
                to="/#tariffs" 
                className="menu-link" 
                onClick={() => handleMenuClick('tariffs')}
              >
                Лицензии
              </Link>
            </li>
            <li>
              <Link 
                to="https://docs.altcor.ru/" 
                className="menu-link" 
                target="_blank" 
                onClick={handleMenuClick}
              >
                Документация
              </Link>
            </li>
            <li>
              <Link 
                to="/#contact-banner" 
                className="menu-link" 
                onClick={() => handleMenuClick('contact-banner')}
              >
                Контакты
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {isMenuOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}
    </nav>
  );
};

export default Menu;